function RowUi({ children, className, ...props }) {
  return (
    <div
      className={
        "w-100 d-flex flex-wrap justify-content-between" +
        (className ? " " + className : "")
      }
      {...props}
    >
      {children}
    </div>
  );
}

export default RowUi;
